import React, {Component} from "react";
import DashboardTrafficReportCard from "./DashboardTrafficReportCard";
import BasePage from "../basePage/BasePage";
import {connect} from "react-redux";
import {getDashboardChartData} from "../../../actions/dashboardActions";
import {loadOperatorTypes} from "../../../actions/dictionaryActions";
import {loadDashboardDynamic} from "../../../actions/offersActions";
import {deductTimezoneOffset, fromDate, isSameDay, toDate} from "../../../utils/dateUtils";
import {CVR, INCOME, LAST_7_DAYS, LEADS, OPERATORS, SUBSCRIBE_1} from "../../../utils/constants";
import {clearNews} from "../../../actions/newsActions";
import {loadAllActiveNetworks} from "../../../actions/advertisingNetworkActions";
import {loadAvailablePartnerBalance} from "../../../actions/partnerBalanceActions";
import PageContent from "../../common/page/PageContent";
import AdvertisingNetworksCard from "./adNetworks/DashboardBannersCard";
import {calculateCr} from "../../../utils/statisticUtils";
import {loadFiltersData} from "../../../actions/filterDataActions";


const MAX_NEWS_PER_LOAD = 5;

class DashboardPage extends Component {

    state = {
        selectedPeriod: LAST_7_DAYS,
        fromDate: fromDate(LAST_7_DAYS),
        toDate: deductTimezoneOffset(new Date()),
        timeout: 0,
        selectedOperatorIds: [],
        mainOffersSwitcherChecked: true,
        disabledOfferIds: [],
        displayedLines: [LEADS, CVR, INCOME],
        filteredOffers: [],
        searchValue: "",
        beforeSearchInputAmount: 0,
        needToFilter: true,
        hasMoreNews: false
    };

    componentDidMount() {
        this.props.getDashboardChartData(fromDate(LAST_7_DAYS), deductTimezoneOffset(new Date()));
        this.props.loadOperatorTypes();
        this.props.loadDashboardDynamic();
        this.props.clearNews();
        this.props.loadAllActiveNetworks();
        this.props.loadAvailablePartnerBalance();
        this.props.loadFiltersData([OPERATORS]);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.loading && !this.props.dynamicLoading && (this.state.needToFilter || (this.props.offersWithClicksOrRebills !== prevProps.offersWithClicksOrRebills))) {
            this.filterOffers();
        }
        if (this.props.news !== prevProps.news) {
            const numberOfLastLoadedItems = this.props.news.length - prevProps.news.length;
            this.setState({
                ...this.state,
                hasMoreNews: MAX_NEWS_PER_LOAD === numberOfLastLoadedItems
            })
        };
    }

    selectFromDate = (fromDate) => {
        if (this.props.loading) {
            return;
        }
        this.setState({fromDate: fromDate, selectedPeriod: null, needToFilter: true})
    };

    selectToDate = (toDate) => {
        if (this.props.loading) {
            return;
        }
        this.setState({toDate: toDate, selectedPeriod: null, needToFilter: true});
    };

    onCloseDatePicker = () => {
        const {fromDate, toDate} = this.state;
        if (!fromDate || !toDate) {
            return;
        }
        this.props.getDashboardChartData(fromDate, toDate);
    };

    selectPeriod = (period) => {
        if (this.props.loading) {
            return;
        }
        const startDate = fromDate(period);
        const endDate = toDate(period);
        this.setState({
            selectedPeriod: period,
            fromDate: startDate,
            toDate: endDate,
            needToFilter: true
        });
        this.props.getDashboardChartData(startDate, endDate);
    };

    selectOperator = (operator) => {
        let selectedOperatorIds = this.state.selectedOperatorIds;
        const index = selectedOperatorIds.indexOf(operator.id);
        if (index === -1) {
            selectedOperatorIds.push(operator.id);
        } else {
            selectedOperatorIds.splice(index, 1);
        }
        this.setState({
            selectedOperatorIds: selectedOperatorIds,
            needToFilter: true
        });
    };

    toggleMainOffersCheckbox = () => {
        const checked = !this.state.mainOffersSwitcherChecked;
        let disabledOfferIds = this.state.disabledOfferIds;
        if (checked) {
            disabledOfferIds = [];
        } else {
            disabledOfferIds = this.props.chartData?.items?.map(offer => offer.offerId);
        }
        this.setState({
            mainOffersSwitcherChecked: checked,
            disabledOfferIds: disabledOfferIds
        });
    };

    toggleOfferCheckbox = (offerId) => {
        const disabledOfferIds = this.state.disabledOfferIds;
        const index = disabledOfferIds.indexOf(offerId);
        if (index === -1) {
            disabledOfferIds.push(offerId);
        } else {
            disabledOfferIds.splice(index, 1);
        }
        this.setState({
            disabledOfferIds: disabledOfferIds,
            mainOffersSwitcherChecked: disabledOfferIds.length === 0
        })
    };

    filterOffers = () => {
        const searchValue = this.state.searchValue && this.state.searchValue.toLocaleLowerCase();
        const selectedOperatorIds = this.state.selectedOperatorIds;
        let offers = this.props.chartData?.items?.filter(chartDataItem => (selectedOperatorIds.length === 0 || selectedOperatorIds.includes(chartDataItem.operatorId)));
        const beforeSearchInputAmount = offers.length;
        offers = offers.filter(offer => (offer.offerId + " " + offer.offerName).toLocaleLowerCase().includes(searchValue))
            .map(offer => {
                const offerDynamic = this.props.dashboardDynamic?.find(offerDynamic => offerDynamic.id === offer.offerId);

                return {
                    id: offer.offerId,
                    offerName: offer.offerName,
                    currentDayLeads: offerDynamic ? offerDynamic.currentDayLeads : 0,
                    prevDayLeads: offerDynamic ? offerDynamic.prevDayLeads : 0,
                    growthPercentage: offerDynamic ? offerDynamic.growthPercentage : 0,
            }
            });
        this.setState({filteredOffers: offers, beforeSearchInputAmount: beforeSearchInputAmount, needToFilter: false});
        return offers;
    };

    onCounterClick = (chartLine) => {
        const displayedLines = this.state.displayedLines;
        const index = displayedLines.indexOf(chartLine);
        if (index === -1) {
            displayedLines.push(chartLine);
        } else {
            displayedLines.splice(index, 1);
        }
        this.setState({displayedLines: displayedLines})
    };

    replaceBuyoutsWithSubscriptions = (areAllOffersBuyout) => {
        const displayedLine = areAllOffersBuyout ? "buyouts" : "subscriptions";
        const replacementLine = areAllOffersBuyout ? "subscriptions" : "buyouts";
        const displayedLines = this.state.displayedLines;
        const index = displayedLines.indexOf(replacementLine);
        if (index > -1) {
            displayedLines[index] = displayedLine;
            this.setState({displayedLines: [...displayedLines]})
        }

    };

    changeSearchValue = (value) => {
        this.setState({searchValue: value, needToFilter: true})
    };


    render() {

        const renderContent = () => {
            return (
                    <PageContent
                        displayContentHeader
                        displaySearchInput
                        onChangeSearchInput={this.changeSearchValue}
                        searchInputAmount={this.state.filteredOffers?.length}
                        beforeSearchInputAmount={this.state.beforeSearchInputAmount}
                        contentEl={
                            <div className="row w-100 nowrap" id="changeRow">
                                            <DashboardTrafficReportCard
                                                chartData={buildChartData(
                                                    this.props.chartData,
                                                    this.state.filteredOffers,
                                                    this.state.disabledOfferIds,
                                                    this.state.selectedOperatorIds,
                                                    this.state.toDate,
                                                    this.replaceBuyoutsWithSubscriptions
                                                )}
                                                isStatisticByDays={this.props.chartData && this.props.chartData.isStatisticByDays}
                                                selectedPeriod={this.state.selectedPeriod}
                                                onCloseDatePicker={this.onCloseDatePicker}
                                                isDatePickerHidden={this.props.loading}
                                                fromDate={this.state.fromDate}
                                                toDate={this.state.toDate}
                                                selectedOperatorIds={this.state.selectedOperatorIds}
                                                selectFromDate={this.selectFromDate}
                                                selectToDate={this.selectToDate}
                                                selectPeriod={this.selectPeriod}
                                                selectOperator={this.selectOperator}
                                                operators={this.props.operators}
                                                loading={this.props.loading}
                                                displayedLines={this.state.displayedLines}
                                                onCounterClick={this.onCounterClick}
                                                filteredOffers={this.state.filteredOffers}
                                                mainOffersSwitcherChecked={this.state.mainOffersSwitcherChecked}
                                                toggleMainOffersCheckbox={this.toggleMainOffersCheckbox}
                                                toggleOfferCheckbox={this.toggleOfferCheckbox}
                                                disabledOfferIds={this.state.disabledOfferIds}
                                            />
                                            <AdvertisingNetworksCard/>
                            </div>
                        }
                    >
                    </PageContent>
            )
        };

        return (
            <BasePage pageName="Дашборд" content={renderContent()}/>
        );
    }
};


function buildChartData(chartData, offers, disabledOfferIds = [], selectedOperatorIds = [], toDate, replaceBuyoutsWithSubscriptions) {
    if (!chartData || !offers) {
        return null;
    }
    const areAllOffersBuyout = offers.length > 0 && !offers.find(offer => offer.billingType !== SUBSCRIBE_1);
    replaceBuyoutsWithSubscriptions(areAllOffersBuyout);
    let labels = chartData.periods;
    let clicks = [], leads = [], rebills = [], trafficbacks = [], cvr = [], income = [];
    chartData?.items?.forEach(function (traffic) {
        if ((selectedOperatorIds.length !== 0 && !selectedOperatorIds.includes(traffic.operatorId)) || disabledOfferIds.includes(traffic.offerId)) {
            return;
        }
        sumTraffic(traffic.clicks, clicks);
        sumTraffic(traffic.leads, leads);
        sumTraffic(traffic.trafficbacks, trafficbacks);
        sumTraffic(traffic.rebills, rebills);
        sumTraffic(traffic.incomes, income);
    });
    cvr = calcCr(leads, clicks, trafficbacks);
    income = income.map(item => Math.round(item));
    const isToday = isSameDay(toDate, deductTimezoneOffset(new Date));
    const chartRebills = chartData.isStatisticByDays ? rebills : [];
    const chartIncomes = chartData.isStatisticByDays ? income : [];
    return {
        labels: labels,
        areAllOffersBuyout: areAllOffersBuyout,
        chartData: [
            {lineName: "clicks", lineData: clicks},
            {lineName: "leads", lineData: leads},
            {lineName: "rebills", lineData: chartRebills},
            {lineName: "trafficbacks", lineData: trafficbacks},
            {lineName: "cvr", lineData: cvr},
            {lineName: "income", lineData: chartIncomes},
        ],
        sum: {
            clicks: {amount: sum(clicks), dynamicPercentage: dynamicPercentage(clicks, isToday)},
            leads: {amount: sum(leads), dynamicPercentage: dynamicPercentage(leads, isToday)},
            rebills: {amount: sum(rebills), dynamicPercentage: dynamicPercentage(rebills, isToday)},
            trafficbacks: {amount: sum(trafficbacks), dynamicPercentage: dynamicPercentage(trafficbacks, isToday)},
            cvr: {amount: calcCrSum(leads, clicks, trafficbacks), dynamicPercentage: dynamicPercentage(cvr, isToday)},
            income: {amount: sum(income), dynamicPercentage: dynamicPercentage(income, isToday)},
        }
    };
}

const sumTraffic = (arr1, arr2) => {
    arr1.forEach(function (element, index) {
        if (arr2[index] === undefined) {
            arr2.push(element);
        } else {
            arr2[index] += element;
        }
    });
};

const calcCr = (leadsArr, clicksArr, trafficBackArr) => {
    const crArr = [];
    leadsArr.forEach((leads, idx) => {
        const clicks = clicksArr[idx];
        const trafficbacks = trafficBackArr[idx];
        const cr = calculateCr(leads, clicks, trafficbacks);
        crArr.push(cr);
    });
    return crArr;
};

const calcCrSum = (leadsArr, clicksArr, tbArr) => {
    const leads = sum(leadsArr);
    const clicks = sum(clicksArr);
    const tb = sum(tbArr);
    return calculateCr(leads, clicks, tb);
};

const sum = (array) => {
    var sum = 0;
    if (array !== undefined && array.length !== 0) {
        array.forEach(function (element) {
            sum += element;
        })
    }
    return sum;
};

const dynamicPercentage = (array, isToday) => {
    const firstElement = array[0];
    const endElement = isToday ? array[array.length - 2] : array[array.length - 1];
    return firstElement
        ? ((endElement - firstElement) / firstElement) * 100
        : endElement
            ? 100
            : 0;
};

function mapStateToProps(state) {
    return {
        chartData: state.dashboardReducer.chartData,
        dashboardDynamic: state.dashboardReducer.dashboardDynamic,
        offersWithClicksOrRebills: state.dashboardReducer.chartData && state.dashboardReducer.chartData.items
            && state.dashboardReducer.chartData.items
                .map(item => {
                    return {
                        offerId: item.offerId,
                        clicks: sum(item.clicks),
                        rebills: sum(item.rebills),
                        subscriptions: sum(item.subscriptions)
                    }
                })
                .filter(item => item.clicks > 0 || item.rebills > 0),
        loading: state.dashboardReducer.loading,
        dynamicLoading: state.dashboardReducer.dynamicLoading,
        availablePartnerBalanceData: state.partnerBalanceReducer.availablePartnerBalanceData,
        operators: state.filterDataReducer.filterData?.operators,
    }
}

export default connect(mapStateToProps, {
    getDashboardChartData,
    loadOperatorTypes,
    loadDashboardDynamic,
    clearNews,
    loadAllActiveNetworks,
    loadAvailablePartnerBalance,
    loadFiltersData
})(DashboardPage);

